<template>
<div>
  <Grid name="filterGridDsr" ref="filterGridDsr" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"  v-bind:databound="dataBound"></Grid>
  <div>
    <b-button v-on:click="addAll()" variant="success">Incluir todos</b-button>
    <b-button variant="danger" v-on:click="excludeAll()">Excluir todos</b-button>
  </div>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import BaseFilter from './BaseFilter'
export default {
  name: 'Dsr',
  extends: BaseFilter,
  components: {
    Grid
  },
  data() {
    return {
      fieldName: 'dsr_id',
      fieldLabel: 'DSR',
      gridRef: 'filterGridDsr',
      preload: [{
        field: 'dealer_id',
        api: 'dealers/lst'
      }],
      schemaModelFields: {},
      url: 'dsr',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '120px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'id',
        title: 'Id',
        width: '120px'
      }, {
        field: 'name',
        title: 'Nome',
        width: '200px'
      }, {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '200px'
      }, {
        field: 'dsr_type',
        title: 'Tipo',
        values: [{
          text: 'Vendedor',
          value: 1
        }, {
          text: 'CV/Vendedor',
          value: 2
        }, {
          text: 'CV',
          value: 3
        }, {
          text: 'Gerente',
          value: 4
        }],
        width: '120px'
      }],
      loaded: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// DsrFilter.vue?5cd4b01a